var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-container",
    { attrs: { "ml-3": "" } },
    [
      _c("v-layout", { staticClass: "main-container", attrs: { wrap: "" } }, [
        _c("div", { staticClass: "main-container" }, [
          _c("h2", [_vm._v(_vm._s(this.art.art_title))]),
          _vm._v(" "),
          _c("p", [_vm._v(_vm._s(this.art.description))])
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "small-container" },
          [
            _c("v-text-field", {
              attrs: { label: "Comment", "single-line": "" },
              model: {
                value: _vm.comment,
                callback: function($$v) {
                  _vm.comment = $$v
                },
                expression: "comment"
              }
            })
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "small-container", attrs: { "mb-5": "" } },
          [
            !this.comment.length
              ? _c("v-btn", { attrs: { disabled: "", large: "" } }, [
                  _vm._v("Send")
                ])
              : _c(
                  "v-btn",
                  {
                    attrs: {
                      depressed: "",
                      dark: "",
                      large: "",
                      color: "primary"
                    },
                    on: {
                      click: function($event) {
                        _vm.save_comment(_vm.art)
                      }
                    }
                  },
                  [_vm._v("Send")]
                ),
            _vm._v(" "),
            _c(
              "v-btn",
              {
                attrs: { depressed: "", dark: "", large: "", color: "black" },
                on: { click: _vm.back }
              },
              [_vm._v("Back")]
            )
          ],
          1
        ),
        _vm._v(" "),
        _c("img", {
          attrs: {
            "mt-5": "",
            src: this.art.url,
            alt: "",
            width: "80%",
            height: "100%"
          }
        })
      ]),
      _vm._v(" "),
      _c(
        "v-snackbar",
        {
          attrs: {
            bottom: _vm.y === "bottom",
            left: _vm.x === "left",
            "multi-line": _vm.mode === "multi-line",
            right: _vm.x === "right",
            timeout: _vm.timeout,
            top: _vm.y === "top",
            vertical: _vm.mode === "vertical"
          },
          model: {
            value: _vm.snackbar,
            callback: function($$v) {
              _vm.snackbar = $$v
            },
            expression: "snackbar"
          }
        },
        [
          _vm._v("\n    " + _vm._s(_vm.text) + "\n    "),
          _c(
            "v-btn",
            {
              attrs: { color: "pink", flat: "" },
              on: { click: _vm.snack_bar_button }
            },
            [_vm._v("\n      Close\n    ")]
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-eb1fcbca", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-eb1fcbca","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/artists/viewed_art.vue
// module id = null
// module chunks = 